BaseHandler = App.loadClass "core::reports/BaseHandler"
StringUtils = App.load "core::utils/string"

class exports.Reports_Fulfillment_SubHandler extends BaseHandler

    init: () ->
        @markers = []
        @layoutUrl      = 'backend/portal/reports/fulfillment'
        @filterUrl      = 'backend/portal/reports/fulfillment/filters'
        @layoutSelector = "#reports_fulfillment_tab"

        @parent.topBuffer = () ->
            return parseInt(App.sidebar.element.outerHeight()) - 55

        @oldMaxZoom = App.map.options.maxZoom
        App.map.options.maxZoom = 13


        # If there are new stage types added,
        # they should be added here alphabetically
        @availableStages = {
            Cancelled: "#BE4948"
            Delivered: "#3A894C"
            Invoiced: "#F89406"
            Mult: "#dddddd"
            Ordered: "#ffffff"
            Processing: "#888888"
            PrintDelTkt: "#e6c2c2"
            ReadytoShip: "#6d5a8c"
            Returned: "#BE4948"
            RMA: "#333333"
            Shipped: "#888888"
            Staged: "#3286AB"
            Transfer: "#825f48"
        }

        @icons = {}

        @generateMarkerIcons()

        @initFilters()


    ###
    #
    # Initialize marker icons. These are the pushpins that represent
    # an order on the map, and they are colorcoded by order stage.
    ###
    generateMarkerIcons: () ->
        for stage, color of @availableStages
            @icons[stage] =  new L.mapbox.marker.icon {
                "marker-size": "medium"
                "marker-color": color
                "marker-symbol": "circle"
            }


    initFilters: () ->
        @resetFilters()

        #invisibalize unnecessary filters
        @parent.filters.findInGroup('farms').disableFilter()
        @parent.filters.findInGroup('fields').disableFilter()


        #special filters
        @parent.filters.importGroup
            name: "Geo-Fulfillment Filters"
            filters: [
                {
                    name: 'statuses'
                    display_name: 'Order Status'
                    class: 'dropup'
                    values: []
                },
            ]

        @setDefaultsAndRun()


    afterLoadLayout: (sel, data) ->

        if @_post?
            @_post.abort()

        if @_timer?
            clearTimeout @_timer

        # Clears old markers
        App.layer_store.empty()

        @markerClusterer = new L.MfMarkerClusterGroup
            iconCreateFunction: @createClusterIcon

        App.layer_store.store "marker_cluster", @markerClusterer


        #@infoWindow = new google.maps.InfoWindow({})

        $("#map_canvas").undelegate().delegate '.get-directions-form .btn', 'click', (e) ->
            e.preventDefault()
            form = $(this).parents('form').serialize()
            window.open "http://maps.google.com/maps?#{form}&hl=en"

        @orderlist = []
        for oid in data.data.orders
            @orderlist.push(oid.id)

        @fetchOrder()


    # Method for creating the marker cluster grouping icons.
    # We want to colorize the icons by order stage, not by number of grouped
    # elements
    createClusterIcon: (cluster) =>
        markers = cluster.getAllChildMarkers()

        counts = {}

        # Count up how many points of
        # each stage are in this cluster
        for i in markers
            if not counts[i.order_stage]?
                counts[i.order_stage] = 0

            counts[i.order_stage]++

        # Count which is the predominant
        # stage in the clustered points
        maxCt = 0
        maxCat = ''
        for k, v of counts
            if v > maxCt
                maxCt = v
                maxCat = k

        # Set icon class, which will determine the color
        maxCat = maxCat.replace /\s/g, ''
        iconClass = 'gfil-marker-cluster-' + StringUtils.allLower(maxCat)

        # This is pretty boilerplate (exact same as the default MfMarkerClusterGroup
        # icon implementation, except for the className setting.)
        return new L.DivIcon({
            html: '
                <div class="hex-outer">
                    <div class="hex-left"></div>
                    <div class="hex-middle"></div>
                    <div class="hex-right"></div>
                </div>
                <div class="hex-inner">
                    <div class="hex-left"></div>
                    <div class="hex-middle"></div>
                    <div class="hex-right"></div>
                </div>
                <div class="count-text">
                    ' + cluster.getChildCount() + '
                </div>
            ',
            className: 'marker-cluster ' + iconClass,
            iconSize: new L.Point(44, 44)
        })



    fetchOrder: () ->
        ids = @orderlist
        ths = this

        if ids.length is 0
            return null


        @_post = $.post 'backend/portal/reports/fulfillment/fulfillment',
            {
                ids: ko.toJSON(ids)
            },
            (data) ->
                if data.data.length isnt 0

                    master = data.data[0]
                    first_stage = master.status_name
                    n = s = master.lat
                    e = w = master.lng
                    infoString = ""
                    warehouse1 = ""
                    warehouse2 = ""
                    warehouseflag = true

                    for order in data.data
                        percent = parseInt((order.status_qty / order.order_qty) * 100)

                        if master.id is order.id

                            if warehouseflag is true

                                infoString = infoString.concat(order.status_name + " " + percent + "%<br>")
                                warehouseflag = false
                                warehouse1 = order.warehouse_name

                            else
                                warehouseflag = true
                                warehouse2 = order.warehouse_name

                        else
                            ths.placeMarker(master, order, infoString, first_stage, warehouse1, warehouse2)

                            master = order

                            infoString = order.status_name + " " + percent + "%<br>"

                            warehouse1 = order.warehouse_name
                            warehouse2 = ""

                            first_stage = master.status_name
                            warehouseflag = false


                    #take care of last order
                    ths.placeMarker(master, order, infoString, first_stage, warehouse1, warehouse2)
                    #set zoom to view all addresses
                    App.map.fitBounds App.layer_store.getBounds()

                    ths.parent.msg.message_writer('success', 'Report Finished')
                    ths.parent.msg.message_writer('hide')


    placeMarker: (master, order, infoString, first_stage, warehouse1, warehouse2) ->

        ths = this
        #build marker information
        infoString = "<table class='table table-condensed'>
                <tr><th>Order</th><td>" + master.id + "</td></tr>
                <tr><th>Grower Name</th><td>" + master.user_name + "</td></tr>
                <tr><th>Fulfillment Stage</th><td>" + infoString + "</td>
                <tr><th>Closest Warehouses</th><td>" + warehouse1 + ", " + warehouse2 + "</td></tr>
            </table>
        "
        Location = [master.lat ? 0, master.lng ? 0]

        if @icons[first_stage.replace /\s/g, '']
            mk = new L.marker(Location, { icon: @icons[first_stage.replace /\s/g, ''] })
            mk.order_stage = first_stage
            mk.bindPopup(infoString)
            @markerClusterer.addLayer mk



    destroy: () ->
        @parent.filters.removeGroup 'Geo-Fulfillment Filters'
        App.map.options.maxZoom = @oldMaxZoom
        App.layer_store.empty()

        @parent.topBuffer = () ->
            return 0

        super()
